<template>
    <section class="home-live-sessions"
             v-if="liveSessions.length > 0">
        <div class="home-live-sessions-header">
            <span class="live-session-label">LIVE</span>
            <span>{{ title }}</span>
        </div>
        <div class="home-live-session-list">
            <router-link v-for="session in liveSessions"
                         :key="session.Code"
                         class="home-live-session"
                         :to="{name: 'sessionDetails', params: {code: session.Code}}">
                <div class="home-live-session-cover">
                    <img-g v-if="session.ThumbnailUri"
                           :src="session.ThumbnailUri" />
                    <span v-else class="icomoon"></span>
                </div>
                <div class="home-live-session-details">
                    <span class="home-live-session-title">{{ session.Name }}</span>
                    <span class="home-live-session-meta">
                        <template v-if="session.Location">{{ session.Location }} - </template>
                        {{ $filters.momentEventTz(session.SessionStartDateTime, 'LT z') }}
                    </span>
                    <span class="home-live-session-headline"
                          v-if="session.Headlines">
                        {{ session.Headlines }}
                    </span>
                </div>
            </router-link>
        </div>
    </section>
</template>

<script>
import Token from './authentication/token'
import Common from './common'
import { AppState } from './appstate'

export default {
    props: ['section'],

    mixins: [
        Token,
        Common
    ],

    computed: {
        title() {
            return this.section?.Title || 'Watch Now';
        }
    },

    methods: {
        async loadLiveSessions() {
            try {
                let result = await this.tryGet(`/api/show/${AppState.showCode}/live-sessions`);

                if(result.Errors && result.Errors.length > 0) {
                    throw result.Errors[0];
                }

                this.liveSessions = result.Result || [];
            } catch(ex) {
                console.error('Could not load live sessions.', ex);
                this.liveSessions = [];
            }
        },

        onEntityUpdated(details) {
            if(details.EntityTypeCode != 'SESSION') {
                return;
            }

            this.loadLiveSessions();
        }
    },

    data() {
        return {
            liveSessions: []
        };
    },

    created() {
        this.loadLiveSessions();
        window.$bus.$on('entity-updated', this.onEntityUpdated);
    },

    beforeUnmount() {
        window.$bus.$off('entity-updated', this.onEntityUpdated);
    }
}
</script>
